var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"qr-code text-center"},[_c('img',{staticClass:"qr-code-img",attrs:{"src":_vm.imgsrc,"alt":"Qr Code per ritirare l'ordine"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }